import { ThemeConfig, theme } from 'antd';
import { lightColors, darkColors } from './colors';

export const getLightTheme = (): ThemeConfig => ({
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: lightColors.primary,
    colorBgContainer: lightColors.surface,
    colorBgLayout: lightColors.background,
    colorText: lightColors.text,
    colorTextSecondary: lightColors.textSecondary,
    colorBorder: lightColors.border,
    colorBorderSecondary: lightColors.borderLight,
    colorSuccess: lightColors.success,
    colorWarning: lightColors.warning,
    colorError: lightColors.error,
    colorInfo: lightColors.info,
    borderRadius: 8,
    fontFamily: '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
  },
  components: {
    Layout: {
      headerBg: lightColors.surface,
      bodyBg: lightColors.background,
      footerBg: lightColors.surface,
    },
    Card: {
      colorBgContainer: lightColors.surface,
    },
    Modal: {
      contentBg: lightColors.surface,
      headerBg: lightColors.surface,
    },
    Drawer: {
      colorBgElevated: lightColors.surface,
    },
    Button: {
      colorBgContainer: lightColors.surface,
    },
    Input: {
      colorBgContainer: lightColors.surface,
    },
    Select: {
      colorBgContainer: lightColors.surface,
      colorBgElevated: lightColors.surface,
    },
  },
});

export const getDarkTheme = (): ThemeConfig => ({
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: darkColors.primary,
    colorBgContainer: darkColors.surface,
    colorBgLayout: darkColors.background,
    colorText: darkColors.text,
    colorTextSecondary: darkColors.textSecondary,
    colorBorder: darkColors.border,
    colorBorderSecondary: darkColors.borderLight,
    colorSuccess: darkColors.success,
    colorWarning: darkColors.warning,
    colorError: darkColors.error,
    colorInfo: darkColors.info,
    borderRadius: 8,
    fontFamily: '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
  },
  components: {
    Layout: {
      headerBg: darkColors.surface,
      bodyBg: darkColors.background,
      footerBg: darkColors.surface,
    },
    Card: {
      colorBgContainer: darkColors.surface,
    },
    Modal: {
      contentBg: darkColors.surface,
      headerBg: darkColors.surface,
    },
    Drawer: {
      colorBgElevated: darkColors.surface,
    },
    Button: {
      colorBgContainer: darkColors.surface,
    },
    Input: {
      colorBgContainer: darkColors.surface,
    },
    Select: {
      colorBgContainer: darkColors.surface,
      colorBgElevated: darkColors.surface,
    },
  },
});
